var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraPermission2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 145,
    viewBox: "0 0 136 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3774 42.5609C78.127 57.3383 70.7521 75.2819 70.7521 75.2819L28.6135 33.0624C28.6135 33.0624 48.6279 27.7835 63.3774 42.5609ZM70.7494 75.2846C70.7494 75.2846 51.7886 81.617 38.0926 67.8959C24.3993 54.1749 28.6108 33.0651 28.6108 33.0651L70.7494 75.2846Z",
    fill: "url(#paint0_linear_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.662 69.0944C68.662 69.0944 61.5381 47.7617 76.9732 32.3544C92.4111 16.9471 116.158 21.6881 116.158 21.6881C116.158 21.6881 122.077 44.1914 105.472 60.7972C98.3894 67.8795 90.4883 70.0891 84.2071 71.8458C77.4689 73.7304 72.5946 75.0935 72.5946 81.3913V90.678H67.0203V75.3209C67.0203 72.614 68.0044 70.0095 69.7729 67.9856L68.662 69.0944Z",
    fill: "url(#paint1_linear_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.726 130.125H42.0249C39.2532 130.125 36.9074 127.842 36.5423 124.783L32.4539 90.6808C32.0257 87.1095 34.8143 83.9666 38.4112 83.9666H102.34C105.937 83.9666 108.725 87.1095 108.297 90.6808L104.209 124.783C103.843 127.842 101.498 130.125 98.726 130.125Z",
    fill: "url(#paint2_linear_2)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 46,
    width: 118,
    height: 18,
    rx: 9,
    fill: "#00F0FF",
    fillOpacity: 0.62
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7426 6.12231H18C11.3726 6.12231 6 11.4949 6 18.1223V22.8649",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130 22.8649L130 18.1223C130 11.4949 124.627 6.12231 118 6.12231L113.257 6.12231",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.257 138.494L118 138.494C124.627 138.494 130 133.121 130 126.494L130 121.751",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 121.751L6 126.494C6 133.121 11.3726 138.494 18 138.494L22.7426 138.494",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2",
    x1: 45.1632,
    y1: 40.8518,
    x2: 69.025,
    y2: 74.1018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338984"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2",
    x1: 92.1046,
    y1: 38.5048,
    x2: 92.1017,
    y2: 90.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28D859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338984"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2",
    x1: 31.6489,
    y1: 131.69,
    x2: 109.102,
    y2: 130.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A80A4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPermission2);
export default __webpack_public_path__ + "static/media/camera_permission_2.de8afb6c.svg";
export { ForwardRef as ReactComponent };